/** The fields of a Custom Reporting sample-grid row that decide whether it can be reported. */
interface ReportableRow {
  status?: string | null;
  statusId?: string | null;
  canReport?: boolean;
}

/**
 * Makes sure a sample-grid row carries `canReport`. The API computes it (a test at
 * Pending Reporting or a later reporting stage, not on hold). An API built before
 * that column existed does not send it, which would lock every row, so the stage
 * shown on the row decides instead: Pending Reporting, or any RP- stage after it.
 * The save procedure re-checks the rule either way.
 */
export function withCanReport<T extends ReportableRow>(row: T): T & { canReport: boolean } {
  if (typeof row.canReport === 'boolean') return row as T & { canReport: boolean };
  const canReport = row.status?.trim() === 'Pending Reporting'
    || (row.statusId ?? '').toUpperCase().startsWith('RP-');
  return { ...row, canReport };
}
